
import { db } from './firebase';
import { doc, getDoc } from 'firebase/firestore';

interface VercelConfig {
  projectId: string;
  teamId: string;
  accessToken: string;
}

const getVercelConfig = async (): Promise<VercelConfig> => {
  const configDoc = await getDoc(doc(db, 'config', 'vercel'));
  if (!configDoc.exists()) {
    throw new Error('Vercel configuration not found');
  }
  return configDoc.data() as VercelConfig;
};

export const addCustomDomain = async (domain: string): Promise<void> => {
  const config = await getVercelConfig();
  
  const response = await fetch(`https://api.vercel.com/v10/projects/${config.projectId}/domains`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${config.accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      name: domain,
      ...(config.teamId ? { teamId: config.teamId } : {}),
    }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to add custom domain');
  }

  console.log('Custom domain added to Vercel successfully:', domain);
};

export const removeCustomDomain = async (domain: string): Promise<void> => {
  const config = await getVercelConfig();
  
  const response = await fetch(`https://api.vercel.com/v10/projects/${config.projectId}/domains/${domain}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${config.accessToken}`,
      ...(config.teamId ? { 'teamId': config.teamId } : {}),
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to remove custom domain');
  }

  console.log('Custom domain removed from Vercel successfully:', domain);
};
